package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Tuvalu Flag (32x24dp)
 *
 * - ISO Alpha-2: TV
 * - ISO Alpha-3: TUV
 * - ISO Numeric: 798
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Tuvalu: ImageVector by lazy {
    ImageVector.Builder(
        name = "Tuvalu:TV:TUV:798:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF00B4FF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-2.004f, 13f)
                lineTo(1.957f, 14.737f)
                lineTo(18.09f, 1.889f)
                lineTo(20.179f, -0.693f)
                lineTo(15.943f, -1.273f)
                lineTo(9.363f, 4.263f)
                lineTo(4.067f, 7.994f)
                lineTo(-2.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-1.462f, 14.217f)
                lineTo(0.556f, 15.225f)
                lineTo(19.429f, -0.933f)
                horizontalLineTo(16.596f)
                lineTo(-1.462f, 14.217f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(20.004f, 13f)
                lineTo(16.043f, 14.737f)
                lineTo(-0.09f, 1.889f)
                lineTo(-2.179f, -0.693f)
                lineTo(2.056f, -1.273f)
                lineTo(8.637f, 4.263f)
                lineTo(13.933f, 7.994f)
                lineTo(20.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(19.869f, 13.873f)
                lineTo(17.851f, 14.882f)
                lineTo(9.815f, 7.964f)
                lineTo(7.432f, 7.191f)
                lineTo(-2.38f, -0.684f)
                horizontalLineTo(0.453f)
                lineTo(10.26f, 7.004f)
                lineTo(12.865f, 7.931f)
                lineTo(19.869f, 13.873f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.985f, 0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.485f, 0f)
                horizontalLineTo(11.484f)
                verticalLineTo(4.5f)
                horizontalLineTo(18f)
                verticalLineTo(9.5f)
                horizontalLineTo(11.484f)
                lineTo(11.5f, 14f)
                horizontalLineTo(6.5f)
                lineTo(6.485f, 9.5f)
                horizontalLineTo(0f)
                verticalLineTo(4.5f)
                horizontalLineTo(6.485f)
                verticalLineTo(0f)
                close()
                moveTo(7.985f, 6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFFFD018)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(26.857f, 10.685f)
            lineTo(27.464f, 9.559f)
            lineTo(28.796f, 9.52f)
            lineTo(27.765f, 8.658f)
            lineTo(28.12f, 7.496f)
            lineTo(27.231f, 8.03f)
            lineTo(26.107f, 7.348f)
            lineTo(26.216f, 8.64f)
            lineTo(25.209f, 9.245f)
            lineTo(26.516f, 9.408f)
            lineTo(26.857f, 10.685f)
            close()
            moveTo(23.464f, 11.559f)
            lineTo(22.857f, 12.685f)
            lineTo(22.516f, 11.408f)
            lineTo(21.209f, 11.245f)
            lineTo(22.216f, 10.64f)
            lineTo(22.107f, 9.348f)
            lineTo(23.231f, 10.03f)
            lineTo(24.12f, 9.496f)
            lineTo(23.765f, 10.658f)
            lineTo(24.796f, 11.52f)
            lineTo(23.464f, 11.559f)
            close()
            moveTo(20.857f, 14.685f)
            lineTo(21.464f, 13.559f)
            lineTo(22.796f, 13.52f)
            lineTo(21.765f, 12.658f)
            lineTo(22.12f, 11.496f)
            lineTo(21.231f, 12.03f)
            lineTo(20.107f, 11.348f)
            lineTo(20.216f, 12.64f)
            lineTo(19.209f, 13.245f)
            lineTo(20.516f, 13.408f)
            lineTo(20.857f, 14.685f)
            close()
            moveTo(16.857f, 18.685f)
            lineTo(17.464f, 17.559f)
            lineTo(18.796f, 17.52f)
            lineTo(17.765f, 16.658f)
            lineTo(18.12f, 15.496f)
            lineTo(17.231f, 16.03f)
            lineTo(16.107f, 15.348f)
            lineTo(16.216f, 16.64f)
            lineTo(15.209f, 17.245f)
            lineTo(16.516f, 17.408f)
            lineTo(16.857f, 18.685f)
            close()
            moveTo(12.974f, 21.736f)
            lineTo(11.874f, 22.388f)
            lineTo(12.24f, 21.118f)
            lineTo(11.203f, 20.305f)
            horizontalLineTo(12.378f)
            lineTo(12.95f, 19.141f)
            lineTo(13.562f, 20.305f)
            horizontalLineTo(14.6f)
            lineTo(13.696f, 21.118f)
            lineTo(14.137f, 22.388f)
            lineTo(12.974f, 21.736f)
            close()
            moveTo(17.464f, 21.559f)
            lineTo(16.857f, 22.685f)
            lineTo(16.516f, 21.408f)
            lineTo(15.209f, 21.245f)
            lineTo(16.216f, 20.64f)
            lineTo(16.107f, 19.348f)
            lineTo(17.231f, 20.03f)
            lineTo(18.12f, 19.496f)
            lineTo(17.765f, 20.658f)
            lineTo(18.796f, 21.52f)
            lineTo(17.464f, 21.559f)
            close()
            moveTo(21.464f, 19.559f)
            lineTo(20.857f, 20.685f)
            lineTo(20.516f, 19.408f)
            lineTo(19.209f, 19.245f)
            lineTo(20.216f, 18.64f)
            lineTo(20.107f, 17.348f)
            lineTo(21.231f, 18.03f)
            lineTo(22.12f, 17.496f)
            lineTo(21.765f, 18.658f)
            lineTo(22.796f, 19.52f)
            lineTo(21.464f, 19.559f)
            close()
            moveTo(25.464f, 17.559f)
            lineTo(24.857f, 18.685f)
            lineTo(24.516f, 17.408f)
            lineTo(23.209f, 17.245f)
            lineTo(24.216f, 16.64f)
            lineTo(24.107f, 15.348f)
            lineTo(25.231f, 16.03f)
            lineTo(26.12f, 15.496f)
            lineTo(25.765f, 16.658f)
            lineTo(26.796f, 17.52f)
            lineTo(25.464f, 17.559f)
            close()
            moveTo(26.857f, 16.685f)
            lineTo(27.464f, 15.559f)
            lineTo(28.796f, 15.52f)
            lineTo(27.765f, 14.658f)
            lineTo(28.12f, 13.496f)
            lineTo(27.231f, 14.03f)
            lineTo(26.107f, 13.348f)
            lineTo(26.216f, 14.64f)
            lineTo(25.209f, 15.245f)
            lineTo(26.516f, 15.408f)
            lineTo(26.857f, 16.685f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun TuvaluPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Tuvalu,
            contentDescription = "Tuvalu Flag"
        )
    }
}
